import { Box, Typography } from "@mui/material";

export default function SectionTitle({ title }: { title: string }) {
  return (
    <Box padding="8px 8px 4px 8px">
      <Typography
        fontWeight={800}
        fontSize="13px"
        sx={{ textTransform: "uppercase" }}
      >
        {title}
      </Typography>
    </Box>
  );
}
